import { Button, RichTextEditor } from "@/components/ui";
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const FormDataSchema = z.object({
  description: z.string().min(1, 'Description is required')
});


const DescriptionForm = ({handleSave, handleCancel, data}:{handleSave: (data: {description: string}) => void; handleCancel: () => void; data: z.infer<typeof FormDataSchema> }) => {
    
    const {
            control,
            handleSubmit,
            formState: { errors },
            reset
          } = useForm({
            resolver: zodResolver(FormDataSchema),
            defaultValues: {
              description: data.description ?? '',
            },
            mode: 'all'
          });
        
    return (
      <div className="flex flex-col gap-4 w-full p-4 lg:p-8 bg-[#F2F2F2]">
        <form onSubmit={handleSubmit(handleSave)} className="flex flex-col gap-4">
           <Controller
          name="description"
          control={control}
          render={({ field }) => (
            <RichTextEditor
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="Description"
              label="Description"
              error={errors.description?.message}
              required
            />
          )}
        />
    

            <div className="flex gap-2 justify-end mt-4">
            <Button
              variant="secondary"
              className=""
              onClick={() => {
                handleCancel();
                reset();
              }}
            >
              Cancel
            </Button>
            <Button
              className=""
              onClick={handleSubmit(handleSave)}
            >
              Save
            </Button>
          </div>
        </form>
      </div>
    )
  };

  export default DescriptionForm;